const _excluded = ["onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useMemo } from 'react';
import { getTheme } from 'office-ui-fabric-react';
import { deepCopy } from 'buzz_lib_shared';
import { DefaultButton } from '../../Button/Default';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContextualMenuSelect = props => {
  const {
      onChange
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const findItemNestPath = (itemList, lookingItemKey, currentWay) => {
    let pathToItem = currentWay !== null && currentWay !== void 0 ? currentWay : [];
    for (let i = 0; i < itemList.length; i++) {
      var _item$items;
      const item = itemList[i];
      if (item.Id === lookingItemKey) {
        pathToItem.push(i);
        return {
          path: pathToItem,
          found: true
        };
      }
      if ((_item$items = item.items) !== null && _item$items !== void 0 && _item$items.length) {
        pathToItem.push(i);
        const newWay = findItemNestPath(item.items, lookingItemKey, pathToItem);
        if (newWay.found) {
          return newWay;
        } else {
          pathToItem.pop();
        }
      }
    }
    return {
      path: pathToItem
    };
  };
  const updateItem = (event, item) => {
    event === null || event === void 0 || event.preventDefault();
    if (!item || item.canCheck === false) {
      return;
    }
    const updatingElementPath = findItemNestPath(props.items, item.key).path;
    const newItems = deepCopy(props.items);
    let refToItem = newItems;
    for (const pathPoint of updatingElementPath) {
      var _refToItem$pathPoint$;
      refToItem = (_refToItem$pathPoint$ = refToItem[pathPoint].items) !== null && _refToItem$pathPoint$ !== void 0 && _refToItem$pathPoint$.length ? refToItem[pathPoint].items : refToItem[pathPoint];
    }
    refToItem.checked = !refToItem.checked;
    onChange(newItems);
  };
  const generateMenuPropItemWithNestedItems = item => {
    const newMenuItem = {
      key: item.Id,
      text: item.Name,
      canCheck: item.canCheck,
      checked: item.checked,
      onClick: updateItem,
      subMenuProps: {
        items: mapItemsToMenuPropsItems(item.items)
      }
    };
    return newMenuItem;
  };
  const generateMenuPropItem = item => {
    const newMenuItem = {
      key: item.Id,
      text: item.Name,
      canCheck: item.canCheck,
      checked: item.checked,
      onClick: updateItem
    };
    return newMenuItem;
  };
  const mapItemsToMenuPropsItems = itemList => {
    return itemList.map(item => {
      var _item$items2;
      if ((_item$items2 = item.items) !== null && _item$items2 !== void 0 && _item$items2.length) {
        return generateMenuPropItemWithNestedItems(item);
      }
      return generateMenuPropItem(item);
    });
  };
  const findCheckedItems = itemList => {
    const checkedList = [];
    if (!itemList) {
      return checkedList;
    }
    for (const element of itemList) {
      var _element$items;
      if (element.checked || (_element$items = element.items) !== null && _element$items !== void 0 && _element$items.length) {
        checkedList.push(_objectSpread(_objectSpread({}, element), {}, {
          items: findCheckedItems(element.items).length ? findCheckedItems(element.items) : undefined
        }));
      }
    }
    return checkedList;
  };
  const generateTitleFromChecked = itemList => {
    const checkedItems = itemList;
    let title = "";
    for (const checkedElement of checkedItems) {
      var _checkedElement$items, _checkedElement$items2;
      if (checkedElement.checked && !((_checkedElement$items = checkedElement.items) !== null && _checkedElement$items !== void 0 && _checkedElement$items.length)) {
        title += " ".concat(checkedElement.Name, ",");
      }
      if ((_checkedElement$items2 = checkedElement.items) !== null && _checkedElement$items2 !== void 0 && _checkedElement$items2.length) {
        title += " ".concat(checkedElement.Name, ": ").concat(generateTitleFromChecked(checkedElement.items));
      }
    }
    title = title.trim();
    if (title.endsWith(',')) {
      return title.slice(0, length - 1);
    }
    return title;
  };
  const generatedTitle = generateTitleFromChecked(findCheckedItems(props.items));
  const buttonTitle = generatedTitle || ' ';
  const menuProps = useMemo(() => ({
    items: mapItemsToMenuPropsItems(props.items)
  }), [JSON.stringify(props.items)]);
  return /*#__PURE__*/_jsx(DefaultButton, _objectSpread({
    text: buttonTitle,
    styles: {
      root: {
        width: "100%",
        paddingLeft: 8,
        paddingRight: 0
      },
      rootHovered: {
        background: 'inherit'
      },
      rootExpanded: {
        background: 'inherit'
      },
      rootPressed: {
        background: 'inherit'
      },
      rootFocused: {
        border: "2px solid ".concat(getTheme().palette.themePrimary)
      },
      textContainer: {
        width: 'calc(100% - 8px - 28px)',
        textAlign: 'left'
      },
      menuIcon: {
        paddingRight: 3
      },
      label: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        display: 'block',
        fontWeight: 400
      }
    },
    menuProps: menuProps
  }, rest));
};